import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { MemberDeleteRequestBody, MemberDeleteResponse } from "./types";

export class MemberDeleteAPI extends BaseAPI<
    MemberDeleteRequestBody,
    MemberDeleteResponse
> {
    protected route = ApiRoutes.member.delete;
    protected method = RequestMethod.DELETE;
    protected params = ["id"]
}
